import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
const SvgIconClose = (props, ref) => _jsx("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "currentColor", ref: ref, ...props, children: _jsx("path", { d: "M17.656 7.757a1 1 0 0 0-1.414-1.414L12 10.586 7.757 6.343a1 1 0 0 0-1.414 1.414L10.585 12l-4.242 4.243a1 1 0 1 0 1.414 1.414L12 13.414l4.242 4.243a1 1 0 0 0 1.414-1.414L13.414 12z" }) });
const ForwardRef = forwardRef(SvgIconClose);
export default ForwardRef;
